import useSWR from 'swr';
import { FindDemoSlotsSchema, findDemoSlotsResponse, FindDemoSlotsResponse } from '../schemas/find-demo-slots';

const generatePath = (args: FindDemoSlotsSchema) => {
  const searchParams = new URLSearchParams();

  if (args.date) {
    searchParams.set('date', args.date.toISOString());
  }

  if (args.limit) {
    searchParams.set('limit', args.limit.toString());
  }

  return `/api/v0/demo-slots?${searchParams.toString()}`;
};

const findDemoSlots = async (args: FindDemoSlotsSchema): Promise<FindDemoSlotsResponse> => {
  const path = generatePath(args);

  const response = await fetch(path, {
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });

  switch (response.status) {
    case 200: {
      return findDemoSlotsResponse.parse(await response.json());
    }

    default: throw new Error('Unexpected response');
  }
};

export const useFindDemoSlots = (args: FindDemoSlotsSchema) => {
  return useSWR(generatePath(args), () => findDemoSlots(args));
};
